import { Grid as MuiGrid, Paper, Typography } from "@mui/material";
import React from "react";
import { CurrencyFormateText } from "@/components/CurrencyFormat";

type RRDJoinConfirmTotalCardProps = {
  totalBudget?: number;
  text?: string;
  textColor?: string;
};

const Grid = MuiGrid as React.ElementType;

function RRDJoinConfirmTotalCard({
  totalBudget = 0,
  text = "Total Budget:",
  textColor = "default",
}: RRDJoinConfirmTotalCardProps) {
  return (
    <Paper className="my-1 px-2 py-3" elevation={2}>
      <Grid container spacing={1} justifyContent="flex-end">
        <Grid item size={{ md: "grow" }}>
          <Typography
            variant="body1"
            className="text-right"
            sx={{ fontWeight: 600 }}
            color={textColor}
          >
            {text}
          </Typography>
        </Grid>
        <Grid item size={{ md: 2 }}>
          <Typography
            variant="body1"
            color="text.primary"
            className="text-center"
            sx={{ fontWeight: 700 }}
          >
            <CurrencyFormateText value={totalBudget} suffix=" USD" />
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default RRDJoinConfirmTotalCard;
